import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  updateOffer: null,
  loading: false,
  error: null,
};

const updateOfferSlice = createSlice({
  name: "updateOffer",
  initialState,

  reducers: {
    fetchUpdateOfferStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchUpdateOfferSuccess: (state, action) => {
      state.loading = false;
      state.updateOffer = action.payload;
      state.error = null;
    },

    fetchUpdateOfferFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchUpdateOfferStart,
  fetchUpdateOfferSuccess,
  fetchUpdateOfferFailure,
} = updateOfferSlice.actions;

export default updateOfferSlice.reducer;